// Registers the service worker for PWA offline + install support.
// Called from index.js. Silently no-ops in unsupported browsers or dev.
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  if (window.location.protocol !== "https:" && window.location.hostname !== "localhost") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Check for updates every 60 min while the tab is open
        setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[PWA] service-worker registration failed:", err);
      });
  });
}

// Ask permission for local push notifications (weather / sowing alerts).
// Returns "granted" | "denied" | "default" | "unsupported".
export async function requestNotificationPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission !== "default") return Notification.permission;
  try {
    return await Notification.requestPermission();
  } catch {
    return "denied";
  }
}

// Fire a local notification via the service worker.
export async function fireLocalNotification({ title, body, url = "/", tag = "agriagent-alert" }) {
  if (!("serviceWorker" in navigator) || Notification.permission !== "granted") return false;
  const reg = await navigator.serviceWorker.ready;
  await reg.showNotification(title || "AgriAgent", {
    body: body || "",
    icon: "/icons/icon-192.png",
    badge: "/icons/icon-192.png",
    tag,
    data: { url },
    vibrate: [80, 40, 80],
  });
  return true;
}
